import { MyStorage } from './MyStorage';

export const myLocalStorage = new MyStorage(localStorage);
export const mySessionStorage = new MyStorage(sessionStorage);
